"use client";

import { useState } from "react";

export default function HeroMedia() {
  const [videoFailed, setVideoFailed] = useState(false);
  const [imgSrc, setImgSrc] = useState("/assets/hero.png");

  return (
    <>
      {!videoFailed && (
        <video
          src="/assets/hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover opacity-80"
          onError={() => setVideoFailed(true)}
        />
      )}
      <img
        src={imgSrc}
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-80"
        onError={() => {
          if (imgSrc === "/assets/hero.png") setImgSrc("/assets/hero.jpg");
        }}
      />
    </>
  );
}
